import React from "react";
import { useMediaQuery } from "react-responsive";

import { MEDIA_QUERIES } from "../../utils/namedConstants";
import { composeItemDefs } from "./composeItemDefs";
import { useSearchResults } from "../../context/DataContext";
import { CellDisplayValues } from "../SearchResultsTable/BodyCell";
import SearchResultsGlobal from "../SearchResultsGlobal/SearchResultsGlobal";
import SearchResultCardList from "../SearchResultCardList/SearchResultCardList";
import SearchResultsTable from "../SearchResultsTable/SearchResultsTable";
import isGlobalSearch from "./isGlobalSearch";

export type ResultColumn = {
    [key: string]: string | CellDisplayValues | undefined;
    funnelbackField: string;
    columnKey: string;
    label?: string;
    cellDisplay?: CellDisplayValues;
    cellClassName?: string;
};

export type SearchResultsProps = {
    collection: string;
};

export const SearchResults = ({ collection }: SearchResultsProps) => {
    const { results } = useSearchResults();
    const isLargeScreen = useMediaQuery({
        query: MEDIA_QUERIES.LARGE,
    });

    const isGlobal = isGlobalSearch(collection);
    const itemDefs = composeItemDefs(collection);

    if (isGlobal) {
        return <SearchResultsGlobal itemDefs={itemDefs} />;
    }

    const maybeTable = isLargeScreen ? (
        <SearchResultsTable itemDefs={itemDefs} />
    ) : (
        <SearchResultCardList itemDefs={itemDefs} />
    );
    const maybeResults = results.length ? maybeTable : null;

    return maybeResults;
};

export default SearchResults;
